/* eslint-disable */
(() => {
  'use strict';
  var e = {
      499: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.Advertisements = void 0);
        var o = r(n(29)),
          i = n(881),
          a = n(676),
          s = n(405),
          u = n(429),
          c = n(987),
          p = (function() {
            function e() {
              (this.ready = !1),
                (this.audienceSet = !1),
                (this.consentSet = !1),
                (this.preferenceManager = new s.PreferenceManager()),
                o.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.INTERNAL_AUDIENCE_UPDATED,
                    this.notify.bind(this),
                  ),
                o.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.CONSENT_READY,
                    this.notify.bind(this),
                  );
            }
            return (
              (e.prototype.isReady = function() {
                return this.ready;
              }),
              (e.prototype.notify = function(e) {
                this.ready ||
                  (e.type === i.PrivacyEvent.INTERNAL_AUDIENCE_UPDATED &&
                    (this.audienceSet = !0),
                  e.type === i.PrivacyEvent.CONSENT_READY &&
                    (this.consentSet = !0),
                  this.consentSet &&
                    this.audienceSet &&
                    ((this.ready = !0),
                    o.default
                      .getGlobal()
                      .dispatchEvent(
                        new Event(i.PrivacyEvent.ADVERTISEMENTS_READY),
                      )));
              }),
              (e.prototype.isConsentedMarketing = function() {
                return this.preferenceManager.getConsent().purposes[
                  c.ConsentCategory.MARKETING
                ];
              }),
              (e.prototype.isChildDirected = function() {
                return (
                  this.preferenceManager.getAudience() ==
                  u.AudienceType.CHILD_DIRECTED
                );
              }),
              (e.prototype.errorComponentNotReady = function(e) {
                throw new Error(
                  ''
                    .concat(
                      a.Constants.ERROR_COMPONENT_NOT_READY,
                      ' Advertisements.',
                    )
                    .concat(e),
                );
              }),
              (e.prototype.getTcf = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getTcf'),
                  this.isChildDirected() ? '' : this.preferenceManager.getTcf()
                );
              }),
              (e.prototype.getUsp = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getUsp'),
                  this.isChildDirected() ? '' : this.preferenceManager.getUsp()
                );
              }),
              (e.prototype.getGpp = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getGpp'),
                  this.isChildDirected() ? '' : this.preferenceManager.getGpp()
                );
              }),
              (e.prototype.getGppSID = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getGppSID'),
                  this.isChildDirected()
                    ? ''
                    : this.preferenceManager.getGppSID()
                );
              }),
              (e.prototype.getCoppa = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getCoppa'),
                  this.isChildDirected() ? '1' : '0'
                );
              }),
              (e.prototype.getTfcd = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getTfcd'),
                  this.isChildDirected() ? '1' : '0'
                );
              }),
              (e.prototype.getLat = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getLat'),
                  this.isChildDirected() || !this.isConsentedMarketing()
                    ? '1'
                    : '0'
                );
              }),
              (e.prototype.getRdp = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getRdp'),
                  this.isChildDirected() || !this.isConsentedMarketing()
                    ? '1'
                    : '0'
                );
              }),
              (e.prototype.getNpa = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getNpa'),
                  this.isChildDirected() || !this.isConsentedMarketing()
                    ? '1'
                    : '0'
                );
              }),
              (e.prototype.getState = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getState'),
                  {
                    tcf: this.getTcf(),
                    usp: this.getUsp(),
                    gpp: this.getGpp(),
                    coppa: this.getCoppa(),
                    tfcd: this.getTfcd(),
                    lat: this.getLat(),
                    rdp: this.getRdp(),
                    npa: this.getNpa(),
                  }
                );
              }),
              (e.prototype.load = function() {
                var e = this.preferenceManager.getAudience(),
                  t = this.preferenceManager.getConsent();
                e &&
                  Object.keys(t).length &&
                  ((this.ready = !0),
                  o.default
                    .getGlobal()
                    .dispatchEvent(
                      new Event(i.PrivacyEvent.ADVERTISEMENTS_READY),
                    ));
              }),
              e
            );
          })();
        t.Advertisements = p;
      },
      429: (e, t) => {
        var n;
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.AudienceType = void 0),
          (function(e) {
            (e.GENERAL = 'GENERAL'), (e.CHILD_DIRECTED = 'CHILD_DIRECTED');
          })(n || (t.AudienceType = n = {}));
      },
      355: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.Audience = void 0);
        var o = r(n(29)),
          i = n(881),
          a = n(429),
          s = n(405),
          u = (function() {
            function e() {
              (this.preferenceManager = new s.PreferenceManager()),
                (this.ready = !1);
            }
            return (
              (e.prototype.dispatchAudienceUpdateEvent = function() {
                o.default
                  .getGlobal()
                  .dispatchEvent(
                    new Event(i.PrivacyEvent.INTERNAL_AUDIENCE_UPDATED),
                  );
              }),
              (e.prototype.isReady = function() {
                return this.ready;
              }),
              (e.prototype.setAudience = function(e) {
                this.preferenceManager.saveAudience(a.AudienceType[e]),
                  this.dispatchAudienceUpdateEvent();
              }),
              (e.prototype.getAudience = function() {
                switch (this.preferenceManager.getAudience()) {
                  case 'GENERAL':
                    return a.AudienceType.GENERAL;
                  case 'CHILD_DIRECTED':
                    return a.AudienceType.CHILD_DIRECTED;
                }
                return a.AudienceType.GENERAL;
              }),
              (e.prototype.load = function() {
                this.preferenceManager.getAudience() &&
                  ((this.ready = !0), this.dispatchAudienceUpdateEvent());
              }),
              e
            );
          })();
        t.Audience = u;
      },
      727: function(e, t, n) {
        var r =
            (this && this.__awaiter) ||
            function(e, t, n, r) {
              return new (n || (n = Promise))(function(o, i) {
                function a(e) {
                  try {
                    u(r.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function s(e) {
                  try {
                    u(r.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function u(e) {
                  var t;
                  e.done
                    ? o(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function(e) {
                            e(t);
                          })).then(a, s);
                }
                u((r = r.apply(e, t || [])).next());
              });
            },
          o =
            (this && this.__generator) ||
            function(e, t) {
              var n,
                r,
                o,
                i = {
                  label: 0,
                  sent: function() {
                    if (1 & o[0]) throw o[1];
                    return o[1];
                  },
                  trys: [],
                  ops: [],
                },
                a = Object.create(
                  ('function' == typeof Iterator ? Iterator : Object).prototype,
                );
              return (
                (a.next = s(0)),
                (a.throw = s(1)),
                (a.return = s(2)),
                'function' == typeof Symbol &&
                  (a[Symbol.iterator] = function() {
                    return this;
                  }),
                a
              );
              function s(s) {
                return function(u) {
                  return (function(s) {
                    if (n)
                      throw new TypeError('Generator is already executing.');
                    for (; a && ((a = 0), s[0] && (i = 0)), i; )
                      try {
                        if (
                          ((n = 1),
                          r &&
                            (o =
                              2 & s[0]
                                ? r.return
                                : s[0]
                                ? r.throw || ((o = r.return) && o.call(r), 0)
                                : r.next) &&
                            !(o = o.call(r, s[1])).done)
                        )
                          return o;
                        switch (
                          ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                        ) {
                          case 0:
                          case 1:
                            o = s;
                            break;
                          case 4:
                            return i.label++, { value: s[1], done: !1 };
                          case 5:
                            i.label++, (r = s[1]), (s = [0]);
                            continue;
                          case 7:
                            (s = i.ops.pop()), i.trys.pop();
                            continue;
                          default:
                            if (
                              !(
                                (o =
                                  (o = i.trys).length > 0 && o[o.length - 1]) ||
                                (6 !== s[0] && 2 !== s[0])
                              )
                            ) {
                              i = 0;
                              continue;
                            }
                            if (
                              3 === s[0] &&
                              (!o || (s[1] > o[0] && s[1] < o[3]))
                            ) {
                              i.label = s[1];
                              break;
                            }
                            if (6 === s[0] && i.label < o[1]) {
                              (i.label = o[1]), (o = s);
                              break;
                            }
                            if (o && i.label < o[2]) {
                              (i.label = o[2]), i.ops.push(s);
                              break;
                            }
                            o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                        }
                        s = t.call(e, i);
                      } catch (e) {
                        (s = [6, e]), (r = 0);
                      } finally {
                        n = o = 0;
                      }
                    if (5 & s[0]) throw s[1];
                    return { value: s[0] ? s[1] : void 0, done: !0 };
                  })([s, u]);
                };
              }
            },
          i =
            (this && this.__importDefault) ||
            function(e) {
              return e && e.__esModule ? e : { default: e };
            };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.HeadlessKetchCmp = void 0);
        var a = n(881),
          s = n(405),
          u = n(676),
          c = n(581),
          p = n(989),
          d = i(n(29)),
          h = (function() {
            function e(e, t, n, r, o, i, a, u) {
              (this.preferenceManager = new s.PreferenceManager()),
                (this.organization = e),
                (this.property = t),
                (this.language = n),
                (this.jurisdiction = o),
                (this.region = r),
                (this.environment = a),
                (this.identity = i);
            }
            return (
              (e.prototype.load = function() {
                var e = this.identity
                    ? this.identity[u.Constants.PARAMOUNT_PRIVACY_ID_KEY]
                    : null,
                  t = this.preferenceManager.getConsent(),
                  n = this.preferenceManager.getConsentConfig(),
                  r = this.preferenceManager.getCMPConfigData();
                !Object.keys(r).length || d.default.needsRefresh(r)
                  ? p.KetchProvider.getCMPConfiguration(
                      this.organization,
                      this.property,
                      {
                        jurisdiction: this.jurisdiction,
                        region: this.region,
                        language: this.language,
                      },
                    )
                  : d.default
                      .getGlobal()
                      .dispatchEvent(
                        new Event(a.PrivacyEvent.INTERNAL_CMP_CONFIG_LOADED),
                      ),
                  (!e && t && Object.keys(t).length) || this.getConsent(),
                  !Object.keys(n).length || d.default.needsRefresh(n)
                    ? c.ParamountProvider.getConsentConfiguration(this.property)
                    : d.default
                        .getGlobal()
                        .dispatchEvent(
                          new Event(
                            a.PrivacyEvent.INTERNAL_CONSENT_CONFIG_LOADED,
                          ),
                        );
              }),
              (e.prototype.getConsent = function() {
                return r(this, void 0, void 0, function() {
                  var e;
                  return o(this, function(t) {
                    return (
                      (e = {}),
                      this.jurisdiction &&
                        (e.jurisdictionCode = this.jurisdiction),
                      [
                        2,
                        p.KetchProvider.getConsent(
                          this.organization,
                          this.property,
                          this.environment,
                          this.identity,
                          e,
                        ),
                      ]
                    );
                  });
                });
              }),
              (e.prototype.getIdentity = function() {
                return this.identity;
              }),
              (e.prototype.getLocation = function() {
                return this.location;
              }),
              (e.prototype.getOrganization = function() {
                return this.organization || '';
              }),
              (e.prototype.getProperty = function() {
                return this.property || '';
              }),
              (e.prototype.getLanguage = function() {
                return this.language || '';
              }),
              (e.prototype.getJurisdiction = function() {
                return this.jurisdiction || '';
              }),
              (e.prototype.getRegion = function() {
                return this.region || '';
              }),
              (e.prototype.getEnvironment = function() {
                return this.environment || '';
              }),
              (e.prototype.setIdentity = function(e) {
                this.identity = e;
              }),
              (e.prototype.setLocation = function(e) {
                this.location = e;
              }),
              (e.prototype.getQRCodeUrl = function() {
                var e = this,
                  t = 'https://global.ketchcdn.com/web/v2/qr/'
                    .concat(this.organization, '/')
                    .concat(this.property, '/preferences.png'),
                  n = [];
                return (
                  this.environment && n.push('env='.concat(this.environment)),
                  this.language && n.push('lang='.concat(this.language)),
                  this.jurisdiction &&
                    n.push('ketch_jurisdiction='.concat(this.jurisdiction)),
                  Object.keys(this.identity || {}).forEach(function(t) {
                    n.push(''.concat(t, '=').concat((e.identity || {})[t]));
                  }),
                  ''.concat(t, '?') + n.join('&')
                );
              }),
              (e.prototype.shouldShowBanner = function() {
                return !0;
              }),
              (e.prototype.getTitle = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.banner ? e.banner.header.title : '';
              }),
              (e.prototype.getDescription = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.banner ? e.banner.description : '';
              }),
              (e.prototype.getMultiParagraphDescription = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.banner ? e.banner.multiParagraph : [];
              }),
              (e.prototype.getPrimaryButtonText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.banner ? e.banner.buttons.primary.text : '';
              }),
              (e.prototype.getSecondaryButtonText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.banner ? e.banner.buttons.secondary.text : '';
              }),
              (e.prototype.getTertiaryButtonText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.banner ? e.banner.buttons.tertiary.text : '';
              }),
              (e.prototype.getSubMenuTitle = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu ? e.submenu.header.title : '';
              }),
              (e.prototype.getSubMenuDescription = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu ? e.submenu.description.body : '';
              }),
              (e.prototype.getSubMenuMultiParagraphDescription = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu
                  ? e.submenu.description.multiParagraph
                  : [];
              }),
              (e.prototype.getSubMenuPrimaryButtonText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu ? e.submenu.footer.actionButtonText : '';
              }),
              (e.prototype.getSubMenuSecondaryButtonText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu
                  ? e.submenu.purposeListHeader.bulkActionButtons.acceptAllText
                  : '';
              }),
              (e.prototype.getSubMenuTertiaryButtonText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu
                  ? e.submenu.purposeListHeader.bulkActionButtons.rejectAllText
                  : '';
              }),
              (e.prototype.getSwitchLabelDefaultText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu
                  ? e.submenu.purposeList.switchButtonLabels.alwaysOnText
                  : '';
              }),
              (e.prototype.getSwitchLabelOnText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu
                  ? e.submenu.purposeList.switchButtonLabels.onText
                  : '';
              }),
              (e.prototype.getSwitchLabelOffText = function() {
                var e = this.preferenceManager.getCMPConfigData();
                return e && e.submenu
                  ? e.submenu.purposeList.switchButtonLabels.offText
                  : '';
              }),
              e
            );
          })();
        t.HeadlessKetchCmp = h;
      },
      676: (e, t) => {
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.Constants = void 0);
        var n = (function() {
          function e() {
            (this.TCF_KEY = 'IABTCF_TCString'),
              (this.USP_KEY = 'IABUSPrivacy_String'),
              (this.GPP_KEY = 'IABGPP_HDR_GppString'),
              (this.GPP_SID_KEY = 'IABGPP_GppSID'),
              (this.AUDIENCE_KEY = 'Paramount_Audience'),
              (this.CONSENT_KEY = 'Paramount_Consent'),
              (this.CONSENT_RESPONSE_KEY = 'Paramount_Consent_Response'),
              (this.CONSENT_CONFIG_KEY = 'Paramount_Consent_Config'),
              (this.IDENTITIES_KEY = 'Paramount_Identities'),
              (this.CMP_CONFIG_DATA_KEY = 'Paramount_CMP_Config'),
              (this.CMP_LEGAL_MENU_TEXT_KEY = 'Paramount_CMP_LegalMenuText');
          }
          return (
            (e.DEFAULT_MODULE_TIMEOUT_MS = 7500),
            (e.PARAMOUNT_PRIVACY_ID_KEY = 'paramount_privacy_id'),
            (e.LEGAL_MENU_TEXT_CONFIG_PATH =
              'https://cdn.privacy.paramount.com/config/menu.json'),
            (e.CONSENT_FAILOVER_RESPONSE = JSON.stringify({
              jurisdictionCode: 'default',
              protocols: {},
              purposes: {
                essential_services: !0,
                analytics: !0,
                functional: !0,
                targeted_advertising: !0,
                social_media: !0,
              },
            })),
            (e.CONSENT_CONFIG_FAILOVER_RESPONSE = JSON.stringify({
              experiences: { default: { showBanner: 0 } },
              consent: {
                default: {
                  essential_services: 1,
                  analytics: 1,
                  functional: 1,
                  targeted_advertising: 1,
                  social_media: 1,
                },
              },
            })),
            (e.ERROR_COMPONENT_NOT_READY =
              'ParamountCMP: Method called before component is ready. Ref: '),
            e
          );
        })();
        t.Constants = n;
      },
      486: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.EventManager = void 0);
        var o = r(n(29)),
          i = n(881),
          a = n(581),
          s = (function() {
            function e() {}
            return (
              (e.load = function() {
                o.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.CONSENT_READY,
                    e.notify.bind(e),
                  ),
                  o.default
                    .getGlobal()
                    .addEventListener(
                      i.PrivacyEvent.CONSENT_UPDATED,
                      e.notify.bind(e),
                    ),
                  o.default
                    .getGlobal()
                    .addEventListener(
                      i.PrivacyEvent.ADVERTISEMENTS_READY,
                      e.notify.bind(e),
                    ),
                  o.default
                    .getGlobal()
                    .addEventListener(
                      i.PrivacyEvent.USER_INTERFACE_READY,
                      e.notify.bind(e),
                    ),
                  a.ParamountProvider.loadLegalMenuConfig();
              }),
              (e.notify = function(t) {
                e.firedEvents[t.type] = t;
              }),
              (e.hasEvent = function(t) {
                return !!e.firedEvents[t];
              }),
              (e.firedEvents = {}),
              e
            );
          })();
        t.EventManager = s;
      },
      993: (e, t) => {
        var n;
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.LogLevel = void 0),
          (function(e) {
            (e[(e.TRACE = 0)] = 'TRACE'),
              (e[(e.DEBUG = 1)] = 'DEBUG'),
              (e[(e.INFO = 2)] = 'INFO'),
              (e[(e.WARN = 3)] = 'WARN'),
              (e[(e.ERROR = 4)] = 'ERROR');
          })(n || (t.LogLevel = n = {}));
      },
      405: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.PreferenceManager = void 0);
        var o = n(429),
          i = r(n(29)),
          a = n(676),
          s = (function() {
            function e() {
              this.constants = new a.Constants();
            }
            return (
              (e.prototype.saveValue = function(e, t, n) {
                i.default.getGlobal().localStorage.setItem(e, t);
              }),
              (e.prototype.getSavedValue = function(e) {
                return i.default.getGlobal().localStorage.getItem(e) || null;
              }),
              (e.prototype.getTcf = function() {
                return this.getSavedValue(this.constants.TCF_KEY) || '';
              }),
              (e.prototype.getUsp = function() {
                var e = this.getSavedValue(this.constants.USP_KEY);
                return 'string' == typeof e ? e : '';
              }),
              (e.prototype.getGpp = function() {
                var e = this.getSavedValue(this.constants.GPP_KEY);
                return 'string' == typeof e ? e : '';
              }),
              (e.prototype.getGppSID = function() {
                var e = this.getSavedValue(this.constants.GPP_SID_KEY);
                return 'string' == typeof e ? e : '';
              }),
              (e.prototype.getConsent = function() {
                var e = this.getSavedValue(this.constants.CONSENT_KEY);
                return e ? JSON.parse(e) : {};
              }),
              (e.prototype.getConsentConfig = function() {
                var e = this.getSavedValue(this.constants.CONSENT_CONFIG_KEY);
                return e ? JSON.parse(e) : {};
              }),
              (e.prototype.getCMPConfigData = function() {
                var e = this.getSavedValue(this.constants.CMP_CONFIG_DATA_KEY);
                return e ? JSON.parse(e) : {};
              }),
              (e.prototype.getAudience = function() {
                var e,
                  t = this.getSavedValue(this.constants.AUDIENCE_KEY);
                return (
                  'GENERAL' == t && (e = o.AudienceType.GENERAL),
                  'CHILD_DIRECTED' == t && (e = o.AudienceType.CHILD_DIRECTED),
                  e || o.AudienceType.GENERAL
                );
              }),
              (e.prototype.getValidatedTcf = function(e) {
                return e || this.getSavedValue(this.constants.TCF_KEY) || '';
              }),
              (e.prototype.getValidatedGpp = function(e) {
                return e || this.getSavedValue(this.constants.GPP_KEY) || '';
              }),
              (e.prototype.getValidatedGppSid = function(e) {
                return (
                  e || this.getSavedValue(this.constants.GPP_SID_KEY) || ''
                );
              }),
              (e.prototype.getValidatedUsp = function(e) {
                return e || '';
              }),
              (e.prototype.saveConsent = function(e) {
                var t = JSON.parse(e),
                  n = this.getValidatedTcf(t.protocols.tcf),
                  r = this.getValidatedGpp(t.protocols.gpp),
                  o = this.getValidatedGppSid(t.protocols.IABGPP_GppSID),
                  i = this.getValidatedUsp(t.protocols.usps);
                this.saveValue(
                  this.constants.TCF_KEY,
                  n,
                  ''.concat(this.constants.TCF_KEY, ' is saved.'),
                ),
                  this.saveValue(
                    this.constants.GPP_KEY,
                    r,
                    ''.concat(this.constants.GPP_KEY, ' is saved.'),
                  ),
                  this.saveValue(
                    this.constants.GPP_SID_KEY,
                    o,
                    ''.concat(this.constants.GPP_SID_KEY, ' is saved.'),
                  ),
                  this.saveValue(
                    this.constants.USP_KEY,
                    i,
                    ''.concat(this.constants.USP_KEY, ' is saved.'),
                  ),
                  this.saveValue(
                    this.constants.CONSENT_KEY,
                    e,
                    ''.concat(this.constants.CONSENT_KEY, ' is saved.'),
                  );
              }),
              (e.prototype.saveAudience = function(e) {
                var t = ''.concat(this.constants.AUDIENCE_KEY, ' is saved.');
                this.saveValue(this.constants.AUDIENCE_KEY, e, t);
              }),
              (e.prototype.saveIdentities = function(e) {
                var t = ''.concat(this.constants.IDENTITIES_KEY, ' is saved.');
                this.saveValue(this.constants.IDENTITIES_KEY, e, t);
              }),
              (e.prototype.saveCMPConfigData = function(e) {
                var t = ''.concat(
                  this.constants.CMP_CONFIG_DATA_KEY,
                  ' is saved.',
                );
                this.saveValue(this.constants.CMP_CONFIG_DATA_KEY, e, t);
              }),
              (e.prototype.saveConsentConfigData = function(e) {
                var t = ''.concat(
                  this.constants.CONSENT_CONFIG_KEY,
                  ' is saved.',
                );
                this.saveValue(this.constants.CONSENT_CONFIG_KEY, e, t);
              }),
              (e.prototype.saveConsentResponse = function(e) {
                var t = ''.concat(
                  this.constants.CONSENT_RESPONSE_KEY,
                  ' is saved.',
                );
                this.saveValue(this.constants.CONSENT_RESPONSE_KEY, e, t);
              }),
              (e.prototype.getConsentResponse = function() {
                var e = this.getSavedValue(this.constants.CONSENT_RESPONSE_KEY);
                return e ? JSON.parse(e) : {};
              }),
              (e.prototype.saveLegalMenuTextData = function(e) {
                var t = ''.concat(
                  this.constants.CMP_LEGAL_MENU_TEXT_KEY,
                  ' is saved.',
                );
                this.saveValue(this.constants.CMP_LEGAL_MENU_TEXT_KEY, e, t);
              }),
              (e.prototype.getLegalMenuTextData = function() {
                var e = this.getSavedValue(
                  this.constants.CMP_LEGAL_MENU_TEXT_KEY,
                );
                return e ? JSON.parse(e) : {};
              }),
              e
            );
          })();
        t.PreferenceManager = s;
      },
      881: (e, t) => {
        var n;
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.PrivacyEvent = void 0),
          (function(e) {
            (e.IDENTITIES_UPDATED = 'IDENTITIES_UPDATED'),
              (e.CONSENT_UPDATED = 'CONSENT_UPDATED'),
              (e.ADVERTISEMENTS_READY = 'ADVERTISEMENTS_READY'),
              (e.CONSENT_READY = 'CONSENT_READY'),
              (e.CONSENT_SYNCED = 'CONSENT_SYNCED'),
              (e.USER_INTERFACE_READY = 'USER_INTERFACE_READY'),
              (e.JURISDICTION_UPDATED = 'JURISDICTION_UPDATED'),
              (e.INTERNAL_AUDIENCE_UPDATED = 'INTERNAL_AUDIENCE_UPDATED'),
              (e.INTERNAL_CONSENT_UPDATED = 'INTERNAL_CONSENT_UPDATED'),
              (e.INTERNAL_IDENTITIES_UPDATED = 'INTERNAL_IDENTITIES_UPDATED'),
              (e.INTERNAL_LOCATION_UPDATED = 'INTERNAL_LOCATION_UPDATED'),
              (e.INTERNAL_CONSENT_CONFIG_LOADED =
                'INTERNAL_CONSENT_CONFIG_LOADED'),
              (e.INTERNAL_CMP_CONFIG_LOADED = 'INTERNAL_CMP_CONFIG_LOADED'),
              (e.INTERNAL_CONSENT_LOADED = 'INTERNAL_CONSENT_LOADED'),
              (e.INTERNAL_LEGAL_MENU_TEXT_LOADED =
                'INTERNAL_LEGAL_MENU_TEXT_LOADED'),
              (e.ERROR = 'ERROR'),
              (e.USER_INTERFACE_ERROR = 'USER_INTERFACE_ERROR');
          })(n || (t.PrivacyEvent = n = {}));
      },
      989: function(e, t, n) {
        var r =
            (this && this.__awaiter) ||
            function(e, t, n, r) {
              return new (n || (n = Promise))(function(o, i) {
                function a(e) {
                  try {
                    u(r.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function s(e) {
                  try {
                    u(r.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function u(e) {
                  var t;
                  e.done
                    ? o(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function(e) {
                            e(t);
                          })).then(a, s);
                }
                u((r = r.apply(e, t || [])).next());
              });
            },
          o =
            (this && this.__generator) ||
            function(e, t) {
              var n,
                r,
                o,
                i = {
                  label: 0,
                  sent: function() {
                    if (1 & o[0]) throw o[1];
                    return o[1];
                  },
                  trys: [],
                  ops: [],
                },
                a = Object.create(
                  ('function' == typeof Iterator ? Iterator : Object).prototype,
                );
              return (
                (a.next = s(0)),
                (a.throw = s(1)),
                (a.return = s(2)),
                'function' == typeof Symbol &&
                  (a[Symbol.iterator] = function() {
                    return this;
                  }),
                a
              );
              function s(s) {
                return function(u) {
                  return (function(s) {
                    if (n)
                      throw new TypeError('Generator is already executing.');
                    for (; a && ((a = 0), s[0] && (i = 0)), i; )
                      try {
                        if (
                          ((n = 1),
                          r &&
                            (o =
                              2 & s[0]
                                ? r.return
                                : s[0]
                                ? r.throw || ((o = r.return) && o.call(r), 0)
                                : r.next) &&
                            !(o = o.call(r, s[1])).done)
                        )
                          return o;
                        switch (
                          ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                        ) {
                          case 0:
                          case 1:
                            o = s;
                            break;
                          case 4:
                            return i.label++, { value: s[1], done: !1 };
                          case 5:
                            i.label++, (r = s[1]), (s = [0]);
                            continue;
                          case 7:
                            (s = i.ops.pop()), i.trys.pop();
                            continue;
                          default:
                            if (
                              !(
                                (o =
                                  (o = i.trys).length > 0 && o[o.length - 1]) ||
                                (6 !== s[0] && 2 !== s[0])
                              )
                            ) {
                              i = 0;
                              continue;
                            }
                            if (
                              3 === s[0] &&
                              (!o || (s[1] > o[0] && s[1] < o[3]))
                            ) {
                              i.label = s[1];
                              break;
                            }
                            if (6 === s[0] && i.label < o[1]) {
                              (i.label = o[1]), (o = s);
                              break;
                            }
                            if (o && i.label < o[2]) {
                              (i.label = o[2]), i.ops.push(s);
                              break;
                            }
                            o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                        }
                        s = t.call(e, i);
                      } catch (e) {
                        (s = [6, e]), (r = 0);
                      } finally {
                        n = o = 0;
                      }
                    if (5 & s[0]) throw s[1];
                    return { value: s[0] ? s[1] : void 0, done: !0 };
                  })([s, u]);
                };
              }
            },
          i =
            (this && this.__importDefault) ||
            function(e) {
              return e && e.__esModule ? e : { default: e };
            };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.KetchProvider = void 0);
        var a = i(n(29)),
          s = n(676),
          u = n(405),
          c = n(881),
          p = (function() {
            function e() {}
            return (
              (e.getConsent = function(t, n, i, s) {
                return r(this, arguments, void 0, function(t, n, r, i, s) {
                  var u;
                  return (
                    void 0 === s && (s = {}),
                    o(this, function(o) {
                      return (
                        (u = Object.assign(
                          {},
                          {
                            organizationCode: t,
                            propertyCode: n,
                            environmentCode: r,
                            identities: i,
                          },
                          s,
                        )),
                        [
                          2,
                          a.default
                            .getGlobal()
                            .fetch(
                              'https://global.ketchcdn.com/web/v3/consent/'.concat(
                                t,
                                '/get',
                              ),
                              {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(u),
                              },
                            )
                            .then(e.consentResponseStatusHander)
                            .then(e.getConsentResponseHandler)
                            .then(function(o) {
                              e.updateConsent(t, n, r, i, o, null);
                            })
                            .catch(e.getConsentErrorHandler),
                        ]
                      );
                    })
                  );
                });
              }),
              (e.consentResponseStatusHander = function(e) {
                return r(this, void 0, void 0, function() {
                  return o(this, function(t) {
                    if (200 === e.status) return [2, e];
                    throw new Error(e.status.toString());
                  });
                });
              }),
              (e.getConsentResponseHandler = function(t) {
                return r(this, void 0, void 0, function() {
                  var n, r, i;
                  return o(this, function(o) {
                    switch (o.label) {
                      case 0:
                        return [4, t.json()];
                      case 1:
                        return (
                          (n = o.sent()),
                          (r = e.preferenceManager.getConsent()),
                          (i = {
                            collectedAt: n.collectedAt,
                            jurisdictionCode: n.jurisdictionCode,
                            protocols: Object.assign(
                              {},
                              r.protocols,
                              n.protocols,
                            ),
                            purposes: Object.assign({}, r.purposes, n.purposes),
                            iat: Date.now(),
                          }),
                          Object.keys(i.purposes).forEach(function(e) {
                            var t = i.purposes[e];
                            ('true' !== t && 'false' !== t) ||
                              (i.purposes[e] = 'true' === t);
                          }),
                          r.jurisdictionCode &&
                            r.jurisdictionCode !== i.jurisdictionCode &&
                            a.default
                              .getGlobal()
                              .dispatchEvent(
                                new Event(c.PrivacyEvent.JURISDICTION_UPDATED),
                              ),
                          e.preferenceManager.saveConsentResponse(
                            JSON.stringify(i),
                          ),
                          a.default
                            .getGlobal()
                            .dispatchEvent(
                              new Event(c.PrivacyEvent.INTERNAL_CONSENT_LOADED),
                            ),
                          [2, n]
                        );
                    }
                  });
                });
              }),
              (e.getConsentErrorHandler = function(t) {
                return r(this, void 0, void 0, function() {
                  var t;
                  return o(this, function(n) {
                    return (
                      (t = e.preferenceManager.getConsent()),
                      Object.keys(t).length
                        ? (a.default
                            .getGlobal()
                            .dispatchEvent(
                              new Event(c.PrivacyEvent.INTERNAL_CONSENT_LOADED),
                            ),
                          [2, t])
                        : (e.preferenceManager.saveConsentResponse(
                            s.Constants.CONSENT_FAILOVER_RESPONSE,
                          ),
                          a.default
                            .getGlobal()
                            .dispatchEvent(
                              new Event(c.PrivacyEvent.INTERNAL_CONSENT_LOADED),
                            ),
                          [2, e.preferenceManager.getConsent()])
                    );
                  });
                });
              }),
              (e.updateConsent = function(t, n, i, u, c, p) {
                return r(this, void 0, void 0, function() {
                  var r, d, h, f, l, g;
                  return o(this, function(o) {
                    if (
                      ((r = e.preferenceManager.getConsent()),
                      (d = c),
                      !u[s.Constants.PARAMOUNT_PRIVACY_ID_KEY] && !p)
                    )
                      return [2, Promise.resolve(r)];
                    if (p) {
                      if (
                        ((h = new URL(
                          'https://global.ketchcdn.com/web/v3/consent/'.concat(
                            t,
                            '/update',
                          ),
                        )),
                        p)
                      )
                        for (f in p)
                          p.hasOwnProperty(f) &&
                            ((l = p[f]), h.searchParams.append(f, l));
                      return [
                        2,
                        a.default
                          .getGlobal()
                          .fetch(h, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                              organizationCode: t,
                              propertyCode: n,
                              environmentCode: i,
                              identities: u,
                              jurisdictionCode: r.jurisdictionCode,
                            }),
                          })
                          .catch(e.updateConsentResponseErrorHandler),
                      ];
                    }
                    return Object.keys(r.purposes || {}).length &&
                      !Object.keys(d.purposes || {}).length
                      ? ((g = {}),
                        Object.keys(r.purposes || {}).forEach(function(e) {
                          g[e] = {
                            allowed: ''.concat(r.purposes[e]),
                            legalBasisCode: r.purposes[e]
                              ? 'consent_optin'
                              : 'consent_optout',
                          };
                        }),
                        [
                          2,
                          a.default
                            .getGlobal()
                            .fetch(
                              'https://global.ketchcdn.com/web/v3/consent/'.concat(
                                t,
                                '/update',
                              ),
                              {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                  organizationCode: t,
                                  propertyCode: n,
                                  environmentCode: i,
                                  identities: u,
                                  purposes: g,
                                  jurisdictionCode: r.jurisdictionCode,
                                }),
                              },
                            )
                            .catch(e.updateConsentResponseErrorHandler),
                        ])
                      : [2, Promise.resolve(r)];
                  });
                });
              }),
              (e.updateConsentResponseErrorHandler = function(e) {
                return r(this, void 0, void 0, function() {
                  return o(this, function(e) {
                    return [2];
                  });
                });
              }),
              (e.getCMPConfiguration = function(t, n) {
                return r(this, arguments, void 0, function(t, n, r) {
                  var i, s;
                  return (
                    void 0 === r && (r = {}),
                    o(this, function(o) {
                      return (
                        (i = 'https://global.ketchcdn.com/web/v3/config/'
                          .concat(t, '/')
                          .concat(n, '/config.json')),
                        (s = Object.keys(r || {})
                          .map(function(e) {
                            return r[e] ? ''.concat(e, '=').concat(r[e]) : null;
                          })
                          .filter(function(e) {
                            return null != e;
                          })
                          .join('&')) && (i += '?'.concat(s)),
                        [
                          2,
                          a.default
                            .getGlobal()
                            .fetch(i)
                            .then(e.cmpConfigurationResponseHandler),
                        ]
                      );
                    })
                  );
                });
              }),
              (e.cmpConfigurationResponseHandler = function(t) {
                return r(this, void 0, void 0, function() {
                  var n, r, i, s, u;
                  return o(this, function(o) {
                    switch (o.label) {
                      case 0:
                        return 200 !== t.status ? [3, 2] : [4, t.json()];
                      case 1:
                        (n = o.sent()) &&
                          n.experiences &&
                          ((r = n.experiences.autoInitiated),
                          (i = n.experiences.userInitiated),
                          (s = /(<([^>]+)>)/gi),
                          r &&
                            i &&
                            ((u = {
                              banner: r && r.content ? r.content.banner : null,
                              submenu: i && i.content ? i.content.modal : null,
                              iat: Date.now(),
                            }).banner &&
                              u.banner.description &&
                              ((u.banner.multiParagraph = u.banner.description
                                .split('</p>')
                                .map(function(e) {
                                  return e.replace(s, '');
                                })
                                .filter(function(e) {
                                  return !!e;
                                })),
                              (u.banner.description = u.banner.description.replace(
                                s,
                                '',
                              ))),
                            u.submenu &&
                              u.submenu.description &&
                              ((u.submenu.description.multiParagraph = u.submenu.description.body
                                .split('</p>')
                                .map(function(e) {
                                  return e.replace(s, '');
                                })
                                .filter(function(e) {
                                  return !!e;
                                })),
                              (u.submenu.description.body = u.submenu.description.body.replace(
                                s,
                                '',
                              ))),
                            e.preferenceManager.saveCMPConfigData(
                              JSON.stringify(u),
                            ),
                            a.default
                              .getGlobal()
                              .dispatchEvent(
                                new Event(
                                  c.PrivacyEvent.INTERNAL_CMP_CONFIG_LOADED,
                                ),
                              ))),
                          (o.label = 2);
                      case 2:
                        return [2, t];
                    }
                  });
                });
              }),
              (e.preferenceManager = new u.PreferenceManager()),
              e
            );
          })();
        t.KetchProvider = p;
      },
      581: function(e, t, n) {
        var r =
            (this && this.__awaiter) ||
            function(e, t, n, r) {
              return new (n || (n = Promise))(function(o, i) {
                function a(e) {
                  try {
                    u(r.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function s(e) {
                  try {
                    u(r.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function u(e) {
                  var t;
                  e.done
                    ? o(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function(e) {
                            e(t);
                          })).then(a, s);
                }
                u((r = r.apply(e, t || [])).next());
              });
            },
          o =
            (this && this.__generator) ||
            function(e, t) {
              var n,
                r,
                o,
                i = {
                  label: 0,
                  sent: function() {
                    if (1 & o[0]) throw o[1];
                    return o[1];
                  },
                  trys: [],
                  ops: [],
                },
                a = Object.create(
                  ('function' == typeof Iterator ? Iterator : Object).prototype,
                );
              return (
                (a.next = s(0)),
                (a.throw = s(1)),
                (a.return = s(2)),
                'function' == typeof Symbol &&
                  (a[Symbol.iterator] = function() {
                    return this;
                  }),
                a
              );
              function s(s) {
                return function(u) {
                  return (function(s) {
                    if (n)
                      throw new TypeError('Generator is already executing.');
                    for (; a && ((a = 0), s[0] && (i = 0)), i; )
                      try {
                        if (
                          ((n = 1),
                          r &&
                            (o =
                              2 & s[0]
                                ? r.return
                                : s[0]
                                ? r.throw || ((o = r.return) && o.call(r), 0)
                                : r.next) &&
                            !(o = o.call(r, s[1])).done)
                        )
                          return o;
                        switch (
                          ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                        ) {
                          case 0:
                          case 1:
                            o = s;
                            break;
                          case 4:
                            return i.label++, { value: s[1], done: !1 };
                          case 5:
                            i.label++, (r = s[1]), (s = [0]);
                            continue;
                          case 7:
                            (s = i.ops.pop()), i.trys.pop();
                            continue;
                          default:
                            if (
                              !(
                                (o =
                                  (o = i.trys).length > 0 && o[o.length - 1]) ||
                                (6 !== s[0] && 2 !== s[0])
                              )
                            ) {
                              i = 0;
                              continue;
                            }
                            if (
                              3 === s[0] &&
                              (!o || (s[1] > o[0] && s[1] < o[3]))
                            ) {
                              i.label = s[1];
                              break;
                            }
                            if (6 === s[0] && i.label < o[1]) {
                              (i.label = o[1]), (o = s);
                              break;
                            }
                            if (o && i.label < o[2]) {
                              (i.label = o[2]), i.ops.push(s);
                              break;
                            }
                            o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                        }
                        s = t.call(e, i);
                      } catch (e) {
                        (s = [6, e]), (r = 0);
                      } finally {
                        n = o = 0;
                      }
                    if (5 & s[0]) throw s[1];
                    return { value: s[0] ? s[1] : void 0, done: !0 };
                  })([s, u]);
                };
              }
            },
          i =
            (this && this.__importDefault) ||
            function(e) {
              return e && e.__esModule ? e : { default: e };
            };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.ParamountProvider = void 0);
        var a = i(n(29)),
          s = n(676),
          u = n(405),
          c = n(881),
          p = (function() {
            function e() {}
            return (
              (e.legalMenuConfigResponse = function(t) {
                return (
                  (t.iat = Date.now()),
                  e.preferenceManager.saveLegalMenuTextData(JSON.stringify(t)),
                  a.default
                    .getGlobal()
                    .dispatchEvent(
                      new Event(c.PrivacyEvent.INTERNAL_LEGAL_MENU_TEXT_LOADED),
                    ),
                  t
                );
              }),
              (e.loadLegalMenuConfig = function() {
                var t = e.preferenceManager.getLegalMenuTextData();
                return a.default.needsRefresh(t)
                  ? a.default
                      .getGlobal()
                      .fetch(s.Constants.LEGAL_MENU_TEXT_CONFIG_PATH)
                      .then(function(e) {
                        return e.json();
                      })
                      .then(e.legalMenuConfigResponse)
                  : (a.default
                      .getGlobal()
                      .dispatchEvent(
                        new Event(
                          c.PrivacyEvent.INTERNAL_LEGAL_MENU_TEXT_LOADED,
                        ),
                      ),
                    Promise.resolve(t));
              }),
              (e.getConsentConfiguration = function(t) {
                return a.default
                  .getGlobal()
                  .fetch(
                    'https://cdn.privacy.paramount.com/config/'.concat(
                      t,
                      '.json',
                    ),
                  )
                  .then(e.consentConfigurationStatusHander)
                  .then(e.consentConfigurationResponseHandler)
                  .catch(e.consentConfigurationErrorHandler);
              }),
              (e.consentConfigurationStatusHander = function(e) {
                return r(this, void 0, void 0, function() {
                  return o(this, function(t) {
                    if (200 === e.status) return [2, e];
                    throw new Error(e.status.toString());
                  });
                });
              }),
              (e.consentConfigurationResponseHandler = function(t) {
                return r(this, void 0, void 0, function() {
                  var n;
                  return o(this, function(r) {
                    switch (r.label) {
                      case 0:
                        return [4, t.json()];
                      case 1:
                        return (
                          ((n = r.sent()).iat = Date.now()),
                          e.preferenceManager.saveConsentConfigData(
                            JSON.stringify(n),
                          ),
                          a.default
                            .getGlobal()
                            .dispatchEvent(
                              new Event(
                                c.PrivacyEvent.INTERNAL_CONSENT_CONFIG_LOADED,
                              ),
                            ),
                          [2, t]
                        );
                    }
                  });
                });
              }),
              (e.consentConfigurationErrorHandler = function(t) {
                return r(this, void 0, void 0, function() {
                  var t;
                  return o(this, function(n) {
                    return (
                      (t = e.preferenceManager.getConsentConfig()),
                      Object.keys(t).length
                        ? (a.default
                            .getGlobal()
                            .dispatchEvent(
                              new Event(
                                c.PrivacyEvent.INTERNAL_CONSENT_CONFIG_LOADED,
                              ),
                            ),
                          [2, t])
                        : (e.preferenceManager.saveConsentConfigData(
                            s.Constants.CONSENT_CONFIG_FAILOVER_RESPONSE,
                          ),
                          a.default
                            .getGlobal()
                            .dispatchEvent(
                              new Event(
                                c.PrivacyEvent.INTERNAL_CONSENT_CONFIG_LOADED,
                              ),
                            ),
                          [2, e.preferenceManager.getConsentConfig()])
                    );
                  });
                });
              }),
              (e.preferenceManager = new u.PreferenceManager()),
              e
            );
          })();
        t.ParamountProvider = p;
      },
      221: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.Configuration = void 0);
        var o = n(881),
          i = n(405),
          a = r(n(29)),
          s = n(486),
          u = (function() {
            function e(e) {
              (this.cmp = e),
                (this.preferenceManager = new i.PreferenceManager());
            }
            return (
              (e.addEventListener = function(e, t, n) {
                void 0 === n && (n = {}),
                  a.default.getGlobal().addEventListener(e, t),
                  s.EventManager.hasEvent(e) &&
                    !n.ignoreInitialEvent &&
                    t(s.EventManager.firedEvents[e]);
              }),
              (e.removeEventListener = function(e, t) {
                a.default.getGlobal().removeEventListener(e, t);
              }),
              (e.prototype.setIdentities = function(e) {
                this.preferenceManager.saveIdentities(JSON.stringify(e)),
                  this.cmp.setIdentity(e),
                  a.default
                    .getGlobal()
                    .dispatchEvent(
                      new Event(o.PrivacyEvent.INTERNAL_IDENTITIES_UPDATED),
                    );
              }),
              (e.prototype.setLocation = function(e) {
                this.cmp.setLocation(e);
              }),
              (e.prototype.load = function() {}),
              e
            );
          })();
        t.Configuration = u;
      },
      987: (e, t) => {
        var n;
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.ConsentCategory = void 0),
          (function(e) {
            (e.ESSENTIAL = 'essential_services'),
              (e.ANALYTICS = 'analytics'),
              (e.FUNCTIONAL = 'functional'),
              (e.MARKETING = 'targeted_advertising'),
              (e.SOCIAL = 'social_media');
          })(n || (t.ConsentCategory = n = {}));
      },
      805: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.Consent = void 0);
        var o = n(405),
          i = n(987),
          a = n(881),
          s = n(429),
          u = n(676),
          c = r(n(29)),
          p = n(989),
          d = (function() {
            function e(e) {
              (this.cmp = e),
                (this.preferenceManager = new o.PreferenceManager()),
                (this.ready = !1),
                (this.audienceSet = !1),
                (this.consentSet = !1),
                (this.consentConfigSet = !1),
                c.default
                  .getGlobal()
                  .addEventListener(
                    a.PrivacyEvent.INTERNAL_AUDIENCE_UPDATED,
                    this.notify.bind(this),
                  ),
                c.default
                  .getGlobal()
                  .addEventListener(
                    a.PrivacyEvent.INTERNAL_CONSENT_LOADED,
                    this.notify.bind(this),
                  ),
                c.default
                  .getGlobal()
                  .addEventListener(
                    a.PrivacyEvent.INTERNAL_CONSENT_CONFIG_LOADED,
                    this.notify.bind(this),
                  );
            }
            return (
              (e.prototype.dispatchConsentReadyEvent = function() {
                c.default
                  .getGlobal()
                  .dispatchEvent(new Event(a.PrivacyEvent.CONSENT_READY));
              }),
              (e.prototype.isReady = function() {
                return this.ready;
              }),
              (e.prototype.saveConsentModel = function() {
                var e = [
                    i.ConsentCategory.ESSENTIAL,
                    i.ConsentCategory.ANALYTICS,
                    i.ConsentCategory.FUNCTIONAL,
                    i.ConsentCategory.MARKETING,
                    i.ConsentCategory.SOCIAL,
                  ],
                  t = this.preferenceManager.getConsentConfig(),
                  n = this.preferenceManager.getConsentResponse(),
                  r = t.consent[n.jurisdictionCode]
                    ? t.consent[n.jurisdictionCode]
                    : t.consent.default;
                e.forEach(function(e) {
                  null == n.purposes[e] && (n.purposes[e] = !!r[e]);
                }),
                  this.preferenceManager.saveConsent(JSON.stringify(n));
              }),
              (e.prototype.notify = function(e) {
                this.ready ||
                  (e.type === a.PrivacyEvent.INTERNAL_AUDIENCE_UPDATED &&
                    (this.audienceSet = !0),
                  e.type === a.PrivacyEvent.INTERNAL_CONSENT_LOADED &&
                    (this.consentSet = !0),
                  e.type === a.PrivacyEvent.INTERNAL_CONSENT_CONFIG_LOADED &&
                    (this.consentConfigSet = !0),
                  this.audienceSet &&
                    this.consentSet &&
                    this.consentConfigSet &&
                    (this.saveConsentModel(),
                    (this.ready = !0),
                    c.default
                      .getGlobal()
                      .dispatchEvent(new Event(a.PrivacyEvent.CONSENT_READY))));
              }),
              (e.prototype.errorComponentNotReady = function(e) {
                throw new Error(
                  ''
                    .concat(u.Constants.ERROR_COMPONENT_NOT_READY, ' Consent.')
                    .concat(e),
                );
              }),
              (e.prototype.getState = function() {
                this.isReady() || this.errorComponentNotReady('getState');
                var e = {};
                return (
                  (e[i.ConsentCategory.ESSENTIAL] = this.getConsent(
                    i.ConsentCategory.ESSENTIAL,
                  )),
                  (e[i.ConsentCategory.ANALYTICS] = this.getConsent(
                    i.ConsentCategory.ANALYTICS,
                  )),
                  (e[i.ConsentCategory.FUNCTIONAL] = this.getConsent(
                    i.ConsentCategory.FUNCTIONAL,
                  )),
                  (e[i.ConsentCategory.MARKETING] = this.getConsent(
                    i.ConsentCategory.MARKETING,
                  )),
                  (e[i.ConsentCategory.SOCIAL] = this.getConsent(
                    i.ConsentCategory.SOCIAL,
                  )),
                  e
                );
              }),
              (e.prototype.getConsent = function(e) {
                return (
                  this.isReady() || this.errorComponentNotReady('getConsent'),
                  this.preferenceManager.getAudience() !==
                    s.AudienceType.CHILD_DIRECTED &&
                    this.preferenceManager.getConsent().purposes[e]
                );
              }),
              (e.prototype.sync = function() {
                var e = this;
                this.isReady() || this.errorComponentNotReady('sync');
                var t = p.KetchProvider.preferenceManager.getConsent(),
                  n = t ? t.collectedAt : null;
                return this.cmp
                  .getConsent()
                  .then(function() {
                    e.saveConsentModel();
                  })
                  .finally(function() {
                    var e = p.KetchProvider.preferenceManager.getConsent(),
                      t = e ? e.collectedAt : null;
                    c.default
                      .getGlobal()
                      .dispatchEvent(new Event(a.PrivacyEvent.CONSENT_SYNCED)),
                      n != t &&
                        c.default
                          .getGlobal()
                          .dispatchEvent(
                            new Event(a.PrivacyEvent.CONSENT_UPDATED),
                          );
                  });
              }),
              (e.prototype.acceptAll = function() {
                var e = this;
                return p.KetchProvider.updateConsent(
                  this.cmp.getOrganization(),
                  this.cmp.getProperty(),
                  this.cmp.getEnvironment(),
                  this.cmp.getIdentity(),
                  null,
                  { setAllowed: 'acceptAll' },
                ).finally(function() {
                  e.sync();
                });
              }),
              (e.prototype.rejectAll = function() {
                var e = this;
                return p.KetchProvider.updateConsent(
                  this.cmp.getOrganization(),
                  this.cmp.getProperty(),
                  this.cmp.getEnvironment(),
                  this.cmp.getIdentity(),
                  null,
                  { setAllowed: 'rejectAll' },
                ).finally(function() {
                  e.sync();
                });
              }),
              (e.prototype.hasGivenExplicitConsent = function() {
                return !!p.KetchProvider.preferenceManager.getConsent()
                  .collectedAt;
              }),
              (e.prototype.getConsentModel = function() {
                var e = p.KetchProvider.preferenceManager.getConsent();
                return e.jurisdictionCode ? e.jurisdictionCode : 'default';
              }),
              (e.prototype.load = function() {
                this.preferenceManager.getAudience() &&
                  Object.keys(this.preferenceManager.getConsent()).length &&
                  Object.keys(this.preferenceManager.getConsentConfig())
                    .length &&
                  ((this.ready = !0), this.dispatchConsentReadyEvent());
              }),
              e
            );
          })();
        t.Consent = d;
      },
      843: (e, t, n) => {
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.ParamountCmp = void 0);
        var r = n(499),
          o = n(355),
          i = n(221),
          a = n(805),
          s = n(253),
          u = n(727),
          c = n(993),
          p = n(429),
          d = n(881),
          h = n(987),
          f = n(486),
          l = (function() {
            function e(e, t, n, c, p) {
              f.EventManager.load(),
                (this.cmp = new u.HeadlessKetchCmp(
                  e.organization,
                  e.property,
                  e.language,
                  n.region,
                  n.jurisdiction,
                  t,
                  c,
                  p,
                )),
                (this.configuration = new i.Configuration(this.cmp)),
                (this.userInterface = new s.HeadlessUserInterface(this.cmp)),
                (this.advertisements = new r.Advertisements()),
                (this.consent = new a.Consent(this.cmp)),
                (this.audience = new o.Audience());
            }
            return (
              (e.prototype.addEventListener = function(t, n, r) {
                void 0 === r && (r = {}), e.addEventListener(t, n, r);
              }),
              (e.addEventListener = function(e, t, n) {
                void 0 === n && (n = {}),
                  i.Configuration.addEventListener(e, t, n);
              }),
              (e.prototype.removeEventListener = function(t, n) {
                e.removeEventListener(t, n);
              }),
              (e.removeEventListener = function(e, t) {
                i.Configuration.removeEventListener(e, t);
              }),
              (e.prototype.setIdentities = function(e) {
                this.configuration.setIdentities(e);
              }),
              (e.prototype.load = function() {
                this.configuration.load(),
                  this.userInterface.load(),
                  this.advertisements.load(),
                  this.consent.load(),
                  this.audience.load(),
                  this.cmp.load();
              }),
              (e.Version = { major: 1, minor: 0, maintenance: 1 }),
              (e.LogLevel = c.LogLevel),
              (e.AudienceType = p.AudienceType),
              (e.PrivacyEvent = d.PrivacyEvent),
              (e.ConsentCategory = h.ConsentCategory),
              e
            );
          })();
        t.ParamountCmp = l;
      },
      253: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.HeadlessUserInterface = void 0);
        var o = n(405),
          i = n(881),
          a = n(676),
          s = r(n(29)),
          u = n(989),
          c = (function() {
            function e(e) {
              (this.cmp = e),
                (this.preferenceManager = new o.PreferenceManager()),
                (this.ready = !1),
                (this.timedOut = !1),
                (this.consentReady = !1),
                (this.cmpConfigDataSet = !1),
                (this.legalMenuTextReady = !1),
                (this.priorConsentPresent = !1);
              var t = this.preferenceManager.getConsent();
              Object.keys(this.preferenceManager.getConsent()).length &&
                (this.priorConsentPresent = !!t.collectedAt),
                s.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.CONSENT_READY,
                    this.notify.bind(this),
                  ),
                s.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.INTERNAL_CMP_CONFIG_LOADED,
                    this.notify.bind(this),
                  ),
                s.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.INTERNAL_LEGAL_MENU_TEXT_LOADED,
                    this.notify.bind(this),
                  ),
                s.default
                  .getGlobal()
                  .addEventListener(
                    i.PrivacyEvent.JURISDICTION_UPDATED,
                    this.notify.bind(this),
                  );
            }
            return (
              (e.prototype.dispatchUserInterfaceReady = function() {
                this.timedOut ||
                  s.default
                    .getGlobal()
                    .dispatchEvent(
                      new Event(i.PrivacyEvent.USER_INTERFACE_READY),
                    );
              }),
              (e.prototype.errorComponentNotReady = function(e) {
                throw new Error(
                  ''
                    .concat(
                      a.Constants.ERROR_COMPONENT_NOT_READY,
                      ' UserInterface.',
                    )
                    .concat(e),
                );
              }),
              (e.prototype.handleTimeout = function() {
                this.isReady() ||
                  ((this.timedOut = !0),
                  s.default
                    .getGlobal()
                    .dispatchEvent(
                      new Event(i.PrivacyEvent.USER_INTERFACE_ERROR),
                    ));
              }),
              (e.prototype.isReady = function() {
                return this.ready;
              }),
              (e.prototype.notify = function(e) {
                e.type === i.PrivacyEvent.JURISDICTION_UPDATED &&
                  u.KetchProvider.getCMPConfiguration(
                    this.cmp.getOrganization(),
                    this.cmp.getProperty(),
                    {
                      jurisdiction: this.cmp.getJurisdiction(),
                      region: this.cmp.getRegion(),
                      language: this.cmp.getLanguage(),
                    },
                  ),
                  this.ready ||
                    (e.type === i.PrivacyEvent.INTERNAL_CMP_CONFIG_LOADED &&
                      (this.cmpConfigDataSet = !0),
                    e.type === i.PrivacyEvent.CONSENT_READY &&
                      (this.consentReady = !0),
                    e.type === i.PrivacyEvent.INTERNAL_LEGAL_MENU_TEXT_LOADED &&
                      (this.legalMenuTextReady = !0),
                    this.cmpConfigDataSet &&
                      this.consentReady &&
                      this.legalMenuTextReady &&
                      ((this.ready = !0), this.dispatchUserInterfaceReady()));
              }),
              (e.prototype.shouldShowBanner = function() {
                this.isReady() ||
                  this.errorComponentNotReady('shouldShowBanner');
                var e = this.preferenceManager.getConsentConfig(),
                  t = this.preferenceManager.getConsent(),
                  n = e.experiences[t.jurisdictionCode]
                    ? e.experiences[t.jurisdictionCode]
                    : e.experiences.default;
                return !(this.priorConsentPresent || !n.showBanner);
              }),
              (e.prototype.getQRCodeUrl = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getQRCodeUrl'),
                  this.cmp.getQRCodeUrl()
                );
              }),
              (e.prototype.getTitle = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getTitle'),
                  this.cmp.getTitle()
                );
              }),
              (e.prototype.getDescription = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getDescription'),
                  this.cmp.getDescription()
                );
              }),
              (e.prototype.getMultiParagraphDescription = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getDescription'),
                  this.cmp.getMultiParagraphDescription()
                );
              }),
              (e.prototype.getPrimaryButtonText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getPrimaryButtonText'),
                  this.cmp.getPrimaryButtonText()
                );
              }),
              (e.prototype.getSecondaryButtonText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSecondaryButtonText'),
                  this.cmp.getSecondaryButtonText()
                );
              }),
              (e.prototype.getTertiaryButtonText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getTertiaryButtonText'),
                  this.cmp.getTertiaryButtonText()
                );
              }),
              (e.prototype.getSubMenuTitle = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSubMenuTitle'),
                  this.cmp.getSubMenuTitle()
                );
              }),
              (e.prototype.getSubMenuDescription = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSubMenuDescription'),
                  this.cmp.getSubMenuDescription()
                );
              }),
              (e.prototype.getSubMenuMultiParagraphDescription = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady(
                      'getSubMenuMultiParagraphDescription',
                    ),
                  this.cmp.getSubMenuMultiParagraphDescription()
                );
              }),
              (e.prototype.getSubMenuPrimaryButtonText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSubMenuPrimaryButtonText'),
                  this.cmp.getSubMenuPrimaryButtonText()
                );
              }),
              (e.prototype.getSubMenuSecondaryButtonText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady(
                      'getSubMenuSecondaryButtonText',
                    ),
                  this.cmp.getSubMenuSecondaryButtonText()
                );
              }),
              (e.prototype.getSubMenuTertiaryButtonText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSubMenuTertiaryButtonText'),
                  this.cmp.getSubMenuTertiaryButtonText()
                );
              }),
              (e.prototype.getSwitchLabelDefaultText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSwitchLabelDefaultText'),
                  this.cmp.getSwitchLabelDefaultText()
                );
              }),
              (e.prototype.getSwitchLabelOnText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSwitchLabelOnText'),
                  this.cmp.getSwitchLabelOnText()
                );
              }),
              (e.prototype.getSwitchLabelOffText = function() {
                return (
                  this.isReady() ||
                    this.errorComponentNotReady('getSwitchLabelOffText'),
                  this.cmp.getSwitchLabelOffText()
                );
              }),
              (e.prototype.getMenuButtonText = function() {
                this.isReady() ||
                  this.errorComponentNotReady('getMenuButtonText');
                var e = this.preferenceManager.getConsent(),
                  t = this.preferenceManager.getLegalMenuTextData(),
                  n = s.default.getGlobal().navigator.language.toLowerCase(),
                  r = n.substr(0, 2),
                  o =
                    t.preferences[e.jurisdictionCode] || t.preferences.default;
                return o[n] || o[r] || o.en || 'Your Privacy Choices';
              }),
              (e.prototype.getState = function() {
                return (
                  this.isReady() || this.errorComponentNotReady('getState'),
                  {
                    shouldShowBanner: this.shouldShowBanner(),
                    qrCodeUrl: this.getQRCodeUrl(),
                    title: this.getTitle(),
                    description: this.getDescription(),
                    multiParagraphDescription: this.getMultiParagraphDescription(),
                    primaryButtonText: this.getPrimaryButtonText(),
                    secondaryButtonText: this.getSecondaryButtonText(),
                    tertiaryButtonText: this.getTertiaryButtonText(),
                    subMenuTitle: this.getSubMenuTitle(),
                    subMenuDescription: this.getSubMenuDescription(),
                    subMenuMultiParagraphDescription: this.getSubMenuMultiParagraphDescription(),
                    subMenuPrimaryButtonText: this.getSubMenuPrimaryButtonText(),
                    subMenuSecondaryButtonText: this.getSubMenuSecondaryButtonText(),
                    subMenuTertiaryButtonText: this.getSubMenuTertiaryButtonText(),
                    menuButtonText: this.getMenuButtonText(),
                    switchLabelDefaultText: this.getSwitchLabelDefaultText(),
                    switchLabelOnText: this.getSwitchLabelOnText(),
                    switchLabelOffText: this.getSwitchLabelOffText(),
                  }
                );
              }),
              (e.prototype.load = function() {
                var e = this.preferenceManager.getConsent(),
                  t = this.preferenceManager.getLegalMenuTextData(),
                  n = this.preferenceManager.getConsentConfig();
                Object.keys(this.preferenceManager.getCMPConfigData()).length &&
                Object.keys(e).length &&
                Object.keys(t).length &&
                Object.keys(n).length
                  ? ((this.ready = !0), this.dispatchUserInterfaceReady())
                  : s.default
                      .getGlobal()
                      .setTimeout(
                        this.handleTimeout.bind(this),
                        a.Constants.DEFAULT_MODULE_TIMEOUT_MS,
                      );
              }),
              e
            );
          })();
        t.HeadlessUserInterface = c;
      },
      156: function(e, t, n) {
        var r =
          (this && this.__importDefault) ||
          function(e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = r(n(29)),
          i = n(843);
        (o.default.getGlobal().ParamountCmp = i.ParamountCmp),
          (t.default = i.ParamountCmp);
      },
      29: (e, t, n) => {
        Object.defineProperty(t, '__esModule', { value: !0 });
        var r = (function() {
          function e() {}
          return (
            (e.getGlobal = function() {
              return n.g;
            }),
            (e.getLocalStorage = function() {
              return e.getGlobal().localStorage;
            }),
            (e.needsRefresh = function(e) {
              return !e || !e.iat || Date.now() - 216e5 > e.iat;
            }),
            e
          );
        })();
        t.default = r;
      },
    },
    t = {};
  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var i = (t[r] = { exports: {} });
    return e[r].call(i.exports, i, i.exports, n), i.exports;
  }
  n.g = (function() {
    if ('object' == typeof globalThis) return globalThis;
    try {
      return this || new Function('return this')();
    } catch (e) {
      if ('object' == typeof window) return window;
    }
  })();
  var r = n(156);
  module.exports = r;
})();
